import React, { Component } from "react";
import classNames from "classnames";
import _ from 'lodash';
import "./LinkList.css";

var md5 = require('md5');

export default class columns extends Component {
  getLinkList = () => {
		const { slices, type, columns } = this.props;
    const list = [];
    let sublist = [];
    let n = 0;
    let maxColumn = columns || 3;
    let count = 0;
    _.forEach(slices, (slice, index) => {
      if (slice.primary && slice.primary.content) {
        _.forEach(slice.primary.content, (element) => {
          if (element.type === 'heading2') {
            count++;
          }
        })
      }
    });

    let columnSize = Math.ceil(count / maxColumn);

    _.forEach(slices, (slice, index) => {
      if (slice.primary && slice.primary.content) {
        _.forEach(slice.primary.content, (element) => {
          if (element.type === 'heading2') {

            if (n >= columnSize) {
              list.push(sublist);
            	n = 0;
              maxColumn--;
              columnSize = Math.ceil((count - (columns - maxColumn) * columnSize) / maxColumn)
            	sublist = [];
            }
            if (element && element.text) {
              sublist.push(element);
              n++;
            }
          }
        })
      }
    })
		if (sublist.length > 0) {
      list.push(sublist);
		}
    return list;
  }

	sectionClasses() {
		let classes = {
			"grid": true,
		}
		return classNames(classes);
	}
	
	render() {
		const list = this.getLinkList();

		return (
			<div className="grid-wrapper">
				{_.map(list, (column, index) => {
					return (<div key={index}>
						{_.map(column,(item, subindex) => {
							return <div key={subindex}><a href={`#${md5(item.text)}`} className={item.type}>{item.text}</a></div>
							})
						}
					</div>)
				})}

			</div>

		);
	}
}	


// WEBPACK FOOTER //
// ./src/components/LinkList/LinkList.js